import React, { FC } from 'react';
import { Card, CardBody } from 'reactstrap';
import { Raffle } from '../../../../shared/orders/raffle';
import { LinkButton } from '../../../components';
import { useTranslation } from '../../../translations';

interface Props {
  readonly raffle: Raffle;
}

export const RaffleListItem: FC<Props> = ({ raffle }) => {
  const { ts } = useTranslation();
  return (
    <Card id={`raffle${raffle.id}`}>
      <CardBody>
        <h4 style={{ marginRight: '30px' }}>
          {raffle.name} <small>(ID: {raffle.id})</small>
        </h4>
        <div className="float-end">
          <LinkButton
            className="view-raffle"
            color="primary"
            outline
            to={`/housekeeping/gatekeeping/${raffle.id}`}
          >
            {ts('manage_silo')}
          </LinkButton>
        </div>
      </CardBody>
    </Card>
  );
};
